import { useRouter } from 'vue-router'

import { languagesList } from '@/constants/languages'
import { findCmsRoutesPath } from '@/utils/cmsRoutesMap/cmsRoutesMap'
import { urlLanguageMapping } from '@/utils/cmsRoutesMap/nonTranslatedPagesMap'
export { translate as __ } from '@hantecmarket/widget-core'
export { useLanguageSwitcher, useForceUpdate } from '@hantecmarket/widget-core'
export { default as dd } from '@/core/utils/dumpDebug'

export function findRouteByUrl(url: string) {
  const router = useRouter()

  const resolvedRoute = router.resolve(url)

  if (resolvedRoute && resolvedRoute.name) {
    return router.resolve({
      params: {
        ...resolvedRoute.params,
        lang: router.currentRoute.value.params.lang
      },
      query: {
        ...resolvedRoute.query
      },
      name: resolvedRoute.name
    })
  }

  return null
}

export const findRouteNameByUrl = (url: string) => findRouteByUrl(url)?.name

/**
 * @deprecated
 * @param href
 */
export const parseButterUrlToAppRoute = (href: string) => findRouteByUrl(href)?.href

export const resolveRouteName = (name: any, params: Record<string, any> = {}) => {
  const router = useRouter()

  if (!router) return

  if (params && Object.keys(params).length) {
    const currentRoute = router?.currentRoute?.value?.path

    const routeLangs: any = findCmsRoutesPath(currentRoute)
    const _params: any = { ...params }
    if (_params.lang === null) {
      _params.lang = 'en'
    }

    if (routeLangs && _params.lang) {
      return routeLangs[_params.lang as any]
    }
  }

  const route = router.resolve({
    params: Object.fromEntries(
      Object.entries({
        ...router.currentRoute.value.params,
        ...(params ?? {})
      }).filter(([key, val]) => val)
    ),
    query: {
      ...router.currentRoute.value.query
    },
    name
  })

  const href = route.href.replace('/en', '')

  return href.slice(-1) === '/' ? href : `${href}/`
}
export const getRouteLanguages = (name: any, params: Record<string, any> = {}) => {
  const router = useRouter()

  const currentRoute = router.resolve({ name, params })
  if (Object.keys(params).length) {
    let path = currentRoute.path

    if (path.slice(-1) !== '/') {
      path += '/'
    }

    const found = findCmsRoutesPath(path)

    if (found) return found
  }

  return Object.fromEntries(
    languagesList.map(({ abbreviation: lang }) => [
      lang,
      (
        router.resolve({
          ...(currentRoute as any),
          params: Object.fromEntries(
            Object.entries({
              ...(currentRoute.params as any),
              ...(params ?? {}),
              ...(lang === 'en' ? { lang: null } : { lang })
            }).filter(([key, val]) => val)
          ),
          name
        } as any).href + '/'
      ).replace('//', '/')
    ])
  )
}

export const checkTranslation = (name: any, params: Record<string, any> = {}) => {
  const router = useRouter()

  if (!router) return false

  const currentRoute = router?.currentRoute?.value?.path

  if (params && Object.keys(params).length) {
    const routeLangs: any = findCmsRoutesPath(currentRoute)
    const _params: any = { ...params }

    if (_params.lang === null) {
      _params.lang = 'en'
    }

    // Check the new mapping for unavailable languages
    if (currentRoute && _params.lang) {
      const unavailableLanguages = urlLanguageMapping[currentRoute] || []
      if (unavailableLanguages.includes(_params.lang)) {
        return false
      }
    }

    if (routeLangs && _params.lang) {
      const resolvedPath = routeLangs[_params.lang as any]
      if (resolvedPath.includes('/404/')) return false
      return true
    }
  }

  const route = router.resolve({
    params: Object.fromEntries(
      Object.entries({
        ...router.currentRoute.value.params,
        ...(params ?? {})
      }).filter(([key, val]) => val)
    ),
    query: {
      ...router.currentRoute.value.query
    },
    name
  })

  const href = route.href.replace('/en', '')
  const finalPath = href.slice(-1) === '/' ? href : `${href}/`

  const url = currentRoute.replace(/^\/(en|es|pt|th|ko|zh-hans|zh-hant)(\/|$)/, '/')
  const unavailableLanguages = urlLanguageMapping[url] || []
  if (unavailableLanguages.includes(params.lang)) {
    return false
  }

  return !finalPath.includes('/404/')
}

export const resolveButterUrl = (href: string | null | undefined) =>
  parseButterUrlToAppRoute(href ?? '') || (href ?? '')

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}
